import { Button, styled } from '../../../base';

export const ButtonsWrapper = styled('div')({
    justifyContent: 'center',
    display: 'flex',
    width: '100%',
});

export const StyledButton = styled(Button)(({ theme }) => ({
    color: theme.palette.grey[600],
    textTransform: 'none',
    '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main,
        },
    },
}));
